module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAAAbFBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALZG2+AAAAI3RSTlMAAjeY+uOD8bQQiEg92PdbB27dkwOPGGV8Iacsnb5gTVUt7a2Xt1YAAACJSURBVHjahZDbDoMgEES3BQS8a1F7t+38/z82kSCrNOl52pxMJrtLf7gqm8ojkKXWANr+iMYwj+7D7tJgQdxab4rBVBIR9RCdI42Ukl4ykfcD0Vzv5Mk3b3VOnpJ3nymQR1nxE1akW22PyDtIC0az+YzOnj1fgSagHkYiNynABFt8xOintlPLDV/nURnHgUDrQwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_pingfen.png
// module id = c1Bs
// module chunks = 1